'use strict';
var searchPartMixin = require('../modules/mixins/searchpart.mixin');

Odigeo.defineWidget('onelinesearchmanager', Odigeo.Widget.extend({
    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
        this.view.toggleFold(this.options.activateSearch);
        this.model.set('isInDetail', this.options.page === 'details');
        if (this.model.get('isInDetail')) {
            this.view.showInDetailsPage();
        }
    },
    displaySearchBar: function(show) {
        this.view.displaySearchBar(show);
    },
    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        bindCustomEvents: function(searchModel) {
            this.searchModel = searchModel;
        },
    })),
    viewClass: Odigeo.View.extend({
        events: {
            'click @mdAddItem': 'onClickAddmdItem',
            'click @hideChangeSearch': 'onClickHideSearch',
        },
        selectors: {
            flightTypeRow: '.flight_type_row',
            directFlightRow: '.direct_flight_row',
            searchButtonCol: '.search_button_col',
            onelineManager: '.oneline_manager',
            singleFlight: '.itinerary_single',
            multipleDestinationFlight: '.itinerary_multiple_destination',
            mdAddItem: '.oneline_md_add_item',
            paxSelectorAsInput: '.pax_input_format',
            paxSelectorAsList: '.pax_list_format',
            iconButton: '.oneline_search_button_change_icon',
            hideChangeSearch: '.hide_change_search',
            multipleDestinationRadio: '.oneline_flight_type_multiple_trip',
            onelineCabinClass: '.oneline_cabin_class',
            directFlightLabel: '.direct_flight_label',
        },
        init: function() {
            this.model.listenSearchModelProperty('editsearch', Odigeo._.bind(this.onEditSearch, this));
            this.listenTo(this.model, 'sync:fetch', this.onDataFromStorageReady);
            this.listenTo(this.model.searchModel, 'change:type', this.onTypeChange);
            this.onTypeChange();
        },
        onClickAddmdItem: function(e) {
            e.stopPropagation();
            e.preventDefault();
            Odigeo.trigger('OneLinerMultiDestination:add');
        },
        onTypeChange: function() {
            var isMultipleDestination = this.widget.options.allowMultipleDestination && !this.model.searchModel.isSingleFlight();

            this.$cachedSelectors.singleFlight.toggleClass('odf-hidden', isMultipleDestination);
            this.$cachedSelectors.multipleDestinationFlight.toggleClass('odf-hidden', !isMultipleDestination);
            this.$cachedSelectors.iconButton.toggleClass('odf-hidden', !isMultipleDestination);
            this.$cachedSelectors.paxSelectorAsInput.toggleClass('odf-hidden', isMultipleDestination);
            this.$cachedSelectors.paxSelectorAsList.toggleClass('odf-hidden', !isMultipleDestination);
        },
        onEditSearch: function(model) {
            if (!Odigeo._.isUndefined(model.changed.editsearch)) {
                this.toggleFold(model.changed.editsearch);
            }
            if (Odigeo.AB.isTrainsFlow && this.model.searchModel.get('trainSearch')) {
                this.$cachedSelectors.multipleDestinationRadio.toggleClass('odf-hidden', true);
                this.$cachedSelectors.onelineCabinClass.toggleClass('odf-hidden', true);
                this.$cachedSelectors.directFlightLabel.html(this.widget.options.translations.onlyDirectTrains);
            }
        },
        displaySearchBar: function(show) {
            this.model.setSearchModelProperty('editsearch', true);
            this.toggleSearchBar(show);
        },
        toggleSearchBar: function(show) {
            this.$cachedSelectors.onelineManager.toggleClass('opened', show);
        },
        onClickHideSearch: function() {
            this.toggleSearchBar(false);
            Odigeo.trigger(this.widget.id + ':hideSearchBar', false);
        },
        setLastSearch: function(searchModel) {
            var lastSearch = {
                searchSegments: searchModel.get('searchSegments'),
                numAdults: searchModel.get('numAdults'),
                numChildren: searchModel.get('numChildren'),
                numInfants: searchModel.get('numInfants'),
                type: searchModel.get('type'),
                directFlightsOnly: searchModel.get('directFlightsOnly'),
            };
            this.model.setSearchModelProperty('lastSearch', lastSearch);
        },
        onDataFromStorageReady: function() {
            var searchSegments = this.model.searchModel.get('searchSegments');
            if (!Odigeo._.isUndefined(searchSegments)) {
                this.model.setSearchModelProperty('editsearch', this.widget.options.activateButton);
                this.setLastSearch(this.model.searchModel);
                if (this.model.get('isInDetail')) {
                    this.model.setSearchModelProperty('isInDetail', true);
                    this.hideSearchOnPax();
                }
            }
            this.onTypeChange();
        },
        toggleFold: function(isUnfolded) {
            if (!(this.widget.options.activateSearch && !isUnfolded)) {
                this.$cachedSelectors.flightTypeRow.toggleClass('active', isUnfolded);
                this.$cachedSelectors.flightTypeRow.toggleClass('odf-hidden', !isUnfolded);
                this.$cachedSelectors.directFlightRow.toggleClass('active', isUnfolded);
                this.$cachedSelectors.searchButtonCol.toggleClass('od-oneline-edit-col', !isUnfolded);
                this.$cachedSelectors.searchButtonCol.toggleClass('od-oneline-button-col', isUnfolded);
                this.$cachedSelectors.onelineManager.toggleClass('expanded', isUnfolded);
            }
        },
        hideSearchOnPax: function() {
            if (!this.model.searchModel.isSingleFlight() && this.model.get('isInDetail')) {
                this.$el.addClass('odf-hidden');
                Odigeo.trigger(this.widget.id + ':showOnelineSearch', false);
            }
        },
        initMetaSearchBar: function() {
            this.$cachedSelectors.flightTypeRow.toggleClass('active', this.widget.options.hideOnLoad);
            this.$cachedSelectors.directFlightRow.toggleClass('active', this.widget.options.hideOnLoad);
            this.$cachedSelectors.onelineManager.toggleClass('od-show-onelinesearch', !this.widget.options.hideOnLoad);
            if (Odigeo.AB.isCssVariationHeaderDesktop && !this.widget.options.hideOnLoad) {
                Odigeo.trigger(this.widget.id + ':showOnelineSearch', true);
            }
        },
        showInDetailsPage: function() {
            Odigeo.Session.set('changeSearchMetaShown', true);
            this.initMetaSearchBar();
            Odigeo.trigger(this.widget.id + ':showOnelineSearch', true);
        },
    }),
}));

